import type { OperationMode } from "../../../../http/lock_calculator/types";

/** The URL parameter that holds the selected tab of the results on the right of the wizard. */
export const RESULTS_TAB_PARAMETER = "lock_results";

/** The results tabs, in the order they are shown. */
export const RESULTS_TAB = {
  generatedConfigurations: 0,
  calculationComparison: 1,
  bom: 2,
  report: 3,
} as const;

/** Where each generation button leads: the list it fills, or the result of the manual solution. */
export const RESULTS_TAB_OF_OPERATION: Record<OperationMode, number> = {
  generateAll: RESULTS_TAB.generatedConfigurations,
  generateFromData: RESULTS_TAB.generatedConfigurations,
  generateManual: RESULTS_TAB.calculationComparison,
};
